import * as React from "react";
import { Job } from "../../../generated/nest-graphql";
import { formatMiles, formatServiceDate, InvoicedService, serviceDateOf } from "../vehicleHistoryData";
import { HistoryCard } from "../HistoryCard";
import { TechnicianIcon } from "../../ui";
import { JobLink } from "./JobLink";
import { JobCardSections } from "./JobCardSections";

/** Who did the job: the technician on its appointment. */
const technicianName = (job: Job) =>
  [job.appointment?.technician?.firstName, job.appointment?.technician?.lastName].filter(Boolean).join(" ").trim() ||
  "No technician";

export const JobCard: React.FC<{
  job: Job;
  isCurrent: boolean;
  /** What was done, from the invoice. */
  services?: InvoicedService[];
  odometer?: string | null;
  /** The newest job in the list: its inspection starts open. */
  isMostRecent?: boolean;
}> = ({ job, isCurrent, services = [], odometer, isMostRecent = false }) => (
  <HistoryCard
    title={
      <span className="flex items-center gap-1.5 min-w-0">
        <TechnicianIcon aria-hidden style={{ fontSize: "1.125rem", color: "#94a3b8", flexShrink: 0 }} />
        <span className="truncate">{technicianName(job)}</span>
      </span>
    }
    subtitle={
      // Indented past the technician icon (18px + 6px gap), so it lines up under the technician's name.
      <span className="block" style={{ paddingLeft: 24 }}>
        {[formatServiceDate(serviceDateOf(job)), job.type, formatMiles(odometer)].filter(Boolean).join(" · ")}
      </span>
    }
    aside={<JobLink job={job} isCurrent={isCurrent} />}
  >
    <JobCardSections job={job} services={services} isMostRecent={isMostRecent} />
  </HistoryCard>
);
